module.exports = __webpack_public_path__ + "img/level6-1.4574c9dd.png";